import { useDispatch } from 'react-redux'
import { setFileView } from '../../../reducers/product.reducer'
import ViewToggle from '../../Component/ViewToggle'

const MediumFunctional = ({ view }) => {
    const dispatch = useDispatch()
    return (
        <ViewToggle value={view} onChange={(mode) => dispatch(setFileView(mode))} />
    )
}

export default MediumFunctional
